export default __webpack_public_path__ + "static/media/v.98e14b62.mp4";